import { styled } from "@mui/material/styles";
import { Box, Paper, Container } from "@mui/material";

export const SliderContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "90vh",
  position: "relative",
  marginBottom: theme.spacing(4),
  "& .slider": {
    width: "100%",
    height: "100%"
  },
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },
  [theme.breakpoints.down("md")]: {
    display: "none"
  }
}));

export const ProductsContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(2),
  maxWidth: "100% !important",
  margin: 0,
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    gap: theme.spacing(4),
    padding: theme.spacing(3)
  }
}));

export const FiltersContainer = styled(Paper)(({ theme }) => ({
  position: "sticky",
  top: theme.spacing(2),
  padding: theme.spacing(3),
  marginBottom: theme.spacing(2),
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  [theme.breakpoints.up("md")]: {
    width: 280,
    flexShrink: 0,
    marginBottom: 0,
    height: "fit-content"
  },
  [theme.breakpoints.down("md")]: {
    display: "none"
  }
}));

export const MobileFiltersDrawer = styled(Paper)(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.drawer,
  borderTopLeftRadius: theme.spacing(2),
  borderTopRightRadius: theme.spacing(2),
  padding: theme.spacing(2),
  maxHeight: "80vh",
  overflowY: "auto",
  [theme.breakpoints.up("md")]: {
    display: "none"
  }
}));

export const ProductsGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: theme.spacing(2),
  gridTemplateColumns: "repeat(2, 1fr)",
  flex: 1,
  [theme.breakpoints.up("sm")]: {
    gap: theme.spacing(3)
  },
  [theme.breakpoints.up("md")]: {
    gridTemplateColumns: "repeat(2, 1fr)"
  },
  [theme.breakpoints.up("lg")]: {
    gridTemplateColumns: "repeat(3, 1fr)"
  },
  [theme.breakpoints.up("xl")]: {
    gridTemplateColumns: "repeat(4, 1fr)"
  }
}));

export const ProductCard = styled(Paper)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  transition: "transform 0.15s ease-in-out",
  "&:hover": {
    transform: "scale(1.02)"
  }
});

// Removed 'theme' because it's not used here
export const ProductImage = styled("img")({
  width: "100%",
  height: "auto",
  objectFit: "cover",
  aspectRatio: "1"
});

// Removed 'theme' because it's not used here
export const FilterButton = styled(Paper)({
  position: "fixed",
  bottom: 16,
  right: 16,
  zIndex: 1300, // If you're using MUI's default zIndex
  borderRadius: "50%",
  width: 48,
  height: 48,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  backgroundColor: "#1976d2", // Or use theme.palette.primary.main
  color: "#fff", // Or use theme.palette.primary.contrastText
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)" // Or use theme.shadows[6]
});
